export class Supplier {
  public supplierName: string;
  public supplierCode: string;
}
